'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiWatch = function TiWatch(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 21.7h3.3c1 0 1.7-0.8 1.7-1.7s-0.7-1.7-1.7-1.7h-1.6v-1.6c0-1-0.8-1.7-1.7-1.7s-1.7 0.7-1.7 1.7v3.3c0 0.9 0.8 1.7 1.7 1.7z m8.3-9.9v-3.5c0-2.7-2.2-5-5-5h-6.6c-2.8 0-5 2.3-5 5v3.5c-2.1 2.1-3.4 5-3.4 8.2s1.3 6.1 3.4 8.2v3.5c0 2.7 2.2 5 5 5h6.6c2.8 0 5-2.3 5-5v-3.5c2.1-2.1 3.4-5 3.4-8.2s-1.3-6.1-3.4-8.2z m-13.3-3.5c0-0.9 0.7-1.6 1.7-1.6h6.6c1 0 1.7 0.7 1.7 1.6v3c-1.5-0.8-3.2-1.3-5-1.3s-3.5 0.5-5 1.3v-3z m10 23.4c0 0.9-0.7 1.6-1.7 1.6h-6.6c-1 0-1.7-0.7-1.7-1.6v-3.1c1.5 0.9 3.2 1.4 5 1.4s3.5-0.5 5-1.4v3.1z m-5-3.4c-4.6 0-8.3-3.7-8.3-8.3s3.7-8.3 8.3-8.3 8.3 3.7 8.3 8.3-3.7 8.3-8.3 8.3z' })
        )
    );
};

exports.default = TiWatch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/watch.js
// module id = 3825
// module chunks = 0